import { render, staticRenderFns } from "./DPdetailsCapsule.vue?vue&type=template&id=5033240d&"
import script from "./DPdetailsCapsule.vue?vue&type=script&lang=js&"
export * from "./DPdetailsCapsule.vue?vue&type=script&lang=js&"
import style0 from "./DPdetailsCapsule.vue?vue&type=style&index=0&id=5033240d&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5033240d')) {
      api.createRecord('5033240d', component.options)
    } else {
      api.reload('5033240d', component.options)
    }
    module.hot.accept("./DPdetailsCapsule.vue?vue&type=template&id=5033240d&", function () {
      api.rerender('5033240d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/directPaymentDetailPages/DPdetailsCapsule.vue"
export default component.exports